import { createSlice } from '@reduxjs/toolkit'
import {
  fetchOneRegistry,
  fetchRegistries,
  sendRegistryToCustoms,
  sendRegistryToCustomsShipment,
} from './thunk'

const initialState = {
  data: [],
  filteredData: [],
  error: '',
  isLoading: false,

  registry: {},
  isRegistryLoading: false,
  errorRegistry: '',

  selectedRegistry: {},

  sendCustomsIsLoading: false,
  sendCustomsError: '',

  sendCustomsShipmentIsLoading: false,
  sendCustomsShipmentError: '',
}

const slice = createSlice({
  name: 'registry',
  initialState,
  reducers: {
    filterData(state, { payload }) {
      state.filteredData = state.data.filter((item) => {
        const makeArray = Object.entries(payload)
        return makeArray.find(([key, value]) => {
          const data = String(item[key]).toLowerCase()
          const searchingData = value.toLowerCase()
          return data.includes(searchingData)
        })
      })
    },
    setSelectedRegistry(state, { payload }) {
      state.selectedRegistry = payload.registry
    },
  },
  extraReducers: {
    [fetchRegistries.pending]: (state) => {
      state.isLoading = true
      state.error = ''
    },
    [fetchRegistries.fulfilled]: (state, { payload }) => {
      state.isLoading = false
      state.data = payload.data
    },
    [fetchRegistries.rejected]: (state, { error }) => {
      state.isLoading = false
      state.error = error.message
    },

    [fetchOneRegistry.pending]: (state) => {
      state.isRegistryLoading = true
      state.errorRegistry = ''
    },
    [fetchOneRegistry.fulfilled]: (state, { payload }) => {
      state.isRegistryLoading = false
      state.registry = payload
    },
    [fetchOneRegistry.rejected]: (state, { error }) => {
      state.isRegistryLoading = false
      state.errorRegistry = error.message
    },

    [sendRegistryToCustoms.pending]: (state) => {
      state.sendCustomsIsLoading = true
      state.sendCustomsError = ''
    },
    [sendRegistryToCustoms.fulfilled]: (state) => {
      state.sendCustomsIsLoading = false
    },
    [sendRegistryToCustoms.rejected]: (state, { error }) => {
      state.sendCustomsIsLoading = false
      state.sendCustomsError = error.message || error
    },

    [sendRegistryToCustomsShipment.pending]: (state) => {
      state.sendCustomsShipmentIsLoading = true
      state.sendCustomsShipmentError = ''
    },
    [sendRegistryToCustomsShipment.fulfilled]: (state) => {
      state.sendCustomsShipmentIsLoading = false
    },
    [sendRegistryToCustomsShipment.rejected]: (state, { error }) => {
      state.sendCustomsShipmentIsLoading = false
      state.sendCustomsShipmentError = error.message || error
    },
  },
})

export const { filterData, setSelectedRegistry } = slice.actions

export const reducer = slice.reducer
export const selectorRegistry = (state) => state[slice.name]

export default slice
